<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useLogsApi } from '../api/logs.hook'
import TutorKanbanLog from './TutorKanbanLog.vue'

defineOptions({
  name: 'TutorKanbanLogPage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  const tutorId = route.params.id as string
  void useLogsApi({ tutorId })
})
</script>

<template>
  <TutorKanbanLog />
</template>
